// Events
import {
  COLLECTION_NEXT_PAGE,
  COLLECTION_PAGINATION_UPDATE,
  COLLECTION_PREVIOUS_PAGE,
  COLLECTION_RUN_BACK_TO_TOP,
  MOUNT_COMPONENTS,
} from 'events';
import { component } from 'picoapp';

import choozy from 'utils/choozy';
// Utils
import getString from 'utils/string';

export default component(async (node, ctx) => {
  const { progressLabel, nextButton, buttonContent, previousButton } = choozy(node);

  let isLastPage = false;
  if (node.dataset.paginationData) {
    try {
      const { cachedPagination } = ctx.getState();

      ctx.hydrate({
        pagination: cachedPagination || JSON.parse(node.dataset.paginationData),
        cachedPagination: null,
      });
      // ctx.hydrate({ pagination: JSON.parse(node.dataset.paginationData) });
    } catch {
      ctx.hydrate({ pagination: {} });
    }

    ctx.on(COLLECTION_PAGINATION_UPDATE, ({ pagination }) => {
      const { currentPage, pageSize, items } = pagination;

      if (items === 0) {
        node.classList.add('hidden');
        return;
      }

      if (previousButton) {
        if (pagination.previousPage.length > 0) {
          node.hidden = false;
        } else {
          node.remove();
          ctx.emit(MOUNT_COMPONENTS);
          return;
        }
      }

      isLastPage = currentPage * pageSize >= items;
      node.classList.remove('hidden', 'is-loading');

      if (buttonContent) {
        buttonContent.forEach((content) => {
          content.textContent = isLastPage
            ? getString('collection.back_to_top')
            : getString('collection.show_more');
        });
      }

      if (progressLabel) {
        progressLabel.textContent = getString('collection.pagination_progress', {
          count: Math.min(currentPage * pageSize, items),
          total: items,
        });
      }
    });

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        if (isLastPage) {
          ctx.emit(COLLECTION_RUN_BACK_TO_TOP);
        } else {
          node.classList.add('is-loading');
          ctx.emit(COLLECTION_NEXT_PAGE);
        }
      });
    }

    if (previousButton) {
      previousButton.addEventListener('click', () => {
        node.classList.add('is-loading');
        ctx.emit(COLLECTION_PREVIOUS_PAGE);
      });
    }
  }
});
